module.exports = __webpack_public_path__ + "static/img/equipamiento-six-3.eec7060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/equipamiento-six-3.jpg
// module id = 0h87
// module chunks = 1